/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetTemplateRepresentation } from './WidgetTemplateRepresentation';
import {
    WidgetTemplateRepresentationFromJSON,
    WidgetTemplateRepresentationFromJSONTyped,
    WidgetTemplateRepresentationToJSON,
    WidgetTemplateRepresentationToJSONTyped,
} from './WidgetTemplateRepresentation';

/**
 * 
 * @export
 * @interface DashboardTemplateRepresentation
 */
export interface DashboardTemplateRepresentation {
    /**
     * 
     * @type {string}
     * @memberof DashboardTemplateRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardTemplateRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardTemplateRepresentation
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof DashboardTemplateRepresentation
     */
    created: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardTemplateRepresentation
     */
    createdBy: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardTemplateRepresentation
     */
    requiredLicenseFeatures: Array<string>;
    /**
     * 
     * @type {Array<WidgetTemplateRepresentation>}
     * @memberof DashboardTemplateRepresentation
     */
    widgetTemplates: Array<WidgetTemplateRepresentation>;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardTemplateRepresentation
     */
    global?: boolean;
}

/**
 * Check if a given object implements the DashboardTemplateRepresentation interface.
 */
export function instanceOfDashboardTemplateRepresentation(value: object): value is DashboardTemplateRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('requiredLicenseFeatures' in value) || value['requiredLicenseFeatures'] === undefined) return false;
    if (!('widgetTemplates' in value) || value['widgetTemplates'] === undefined) return false;
    return true;
}

export function DashboardTemplateRepresentationFromJSON(json: any): DashboardTemplateRepresentation {
    return DashboardTemplateRepresentationFromJSONTyped(json, false);
}

export function DashboardTemplateRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardTemplateRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'created': json['created'],
        'createdBy': json['createdBy'],
        'requiredLicenseFeatures': json['requiredLicenseFeatures'],
        'widgetTemplates': ((json['widgetTemplates'] as Array<any>).map(WidgetTemplateRepresentationFromJSON)),
        'global': json['global'] == null ? undefined : json['global'],
    };
}

export function DashboardTemplateRepresentationToJSON(json: any): DashboardTemplateRepresentation {
    return DashboardTemplateRepresentationToJSONTyped(json, false);
}

export function DashboardTemplateRepresentationToJSONTyped(value?: DashboardTemplateRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
        'created': value['created'],
        'createdBy': value['createdBy'],
        'requiredLicenseFeatures': value['requiredLicenseFeatures'],
        'widgetTemplates': ((value['widgetTemplates'] as Array<any>).map(WidgetTemplateRepresentationToJSON)),
        'global': value['global'],
    };
}

